module.exports = __webpack_public_path__ + "static/media/travauxsol.821c547a.png";